import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { EventEmitter, Injectable, Output } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Observable, of } from "rxjs";
import { DialogoGenericoComponent } from "src/app/shared/dialogo-generico/dialogo-generico.component";
import { catchError, map } from 'rxjs/operators';
import { Constanst } from "../constants/constans.component";
import { LocalStorageService } from "./local-storage.service";

@Injectable({
  providedIn: 'root'
})
export class HelperClassService {

  iconDialog: string;
  private data: any;

  @Output() notifierNewChangeBudget: EventEmitter<string> = new EventEmitter;
  @Output() notifierUpdatedUser: EventEmitter<string> = new EventEmitter;

  constructor(public dialogModalGeneric: MatDialog, private http: HttpClient, private localStorageService: LocalStorageService) { }

  public openDialogGeneric(widthIn: string, disableCloseIn: boolean,
    messageIn: string, btCancelIn: boolean, btAcceptIn: boolean, btCloseIn: boolean, actionBtCancelIn: string, actionBtAcceptIn: string, actionBtCloseIn: string, resultIn: string): any {


    if (resultIn == 'error') {
      this.iconDialog = 'highlight_off';
    } else if (resultIn == 'success') {
      this.iconDialog = 'check_circle_outline';
    } else if (resultIn == 'info') {
      this.iconDialog = 'warning';
    }
    const dialog = this.dialogModalGeneric.open(DialogoGenericoComponent, {
      width: widthIn,
      disableClose: disableCloseIn,
      data: {
        icon: this.iconDialog,
        message: messageIn,
        btCancel: btCancelIn,
        btAccept: btAcceptIn,
        btClose: btCloseIn,
        actionBtCancel: actionBtCancelIn,
        actionBtAccept: actionBtAcceptIn,
        actionBtClose: actionBtCloseIn,
        result: resultIn
      }
    });
    return dialog;
  }

  setData(data: any) {
    this.data = data;
  }

  getData() {
    return this.data;
  }

  toBase64Image = async (url: string) => {
    var res = await fetch(url);
    var blob = await res.blob();

    const result = await new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.addEventListener("load", function () {
        resolve(reader.result);
      }, false);

      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(blob);
    });
    return result
  }

  validateViewMobileScreen(screenWidth: number) {
    let result: boolean = false;
    if (screenWidth <= 575) {
      result = true;
    }
    return result;
  }

  localStorageClear() {
    this.localStorageService.removeItem(Constanst.STORAGE_DATA_CODE);
    this.localStorageService.removeItem(Constanst.STORAGE_DATA_USER);
    this.localStorageService.removeItem(Constanst.STORAGE_DATA_FIRSTADMISSION)
    this.localStorageService.removeItem(Constanst.STORAGE_DATA_PROFILE);
    this.localStorageService.removeItem(Constanst.STORAGE_DATA_USERNAME);
    localStorage.removeItem(Constanst.STORAGE_DATA_CONSULTDATE);
    localStorage.removeItem(Constanst.STORAGE_DATA_SCREENTYPE);
    localStorage.removeItem(Constanst.STORAGE_DATA_MONTHCONSULT);
    localStorage.removeItem(Constanst.STORAGE_DATA_ANIOCONSULT);
    localStorage.removeItem(Constanst.STORAGE_DATA_USERSELECT);
    localStorage.removeItem(Constanst.STORAGE_DATA_BUDGETSELECT);
  }

  validateDocumentExists(url: string): Observable<boolean> {
    return this.http.head(url, { observe: 'response' }).pipe(
      map(response => response.status === 200),
      catchError((error: HttpErrorResponse) => {
        return of(false);
      })
    );
  }

}